import * as React from "react";
import { ListItem, UnorderedList } from "scuid-x";
import { DocTips as DocTipsConsts } from "../constants/DocTips";
import { DocType } from "../constants/DocType";

interface DocTipsProps {
  docType: DocType;
}

export const DocTips: React.SFC<DocTipsProps> = (props) => {
  const docTips = DocTipsConsts.getDocTips(props.docType);
  if (docTips.length === 0) {
    return (null);
  }

  const listItems = docTips.map( (tip) => (
    <ListItem key={tip.tip}>
      {tip.tip}
    </ListItem>
  ));

  return (
    <UnorderedList>
      {listItems}
    </UnorderedList>
  );
};



// WEBPACK FOOTER //
// ./src/components/DocTips.tsx